import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Home from '@/components/home'
import HomeIndex from '@/components/home/homeIndex'
import Goaboard from '@/components/home/goaboard'
import ConsularCertification from '@/components/home/consularCertification'
import TranslationService from '@/components/home/translationService'
import Announcement from '@/components/home/announcement'
import Search from '@/components/home/search'
import InstitutionalOverview from '@/components/home/institutionalOverview'
import ContactUs from '@/components/home/contactUs'
import Player from '@/components/home/player'
import Guide from '@/components/home/guide'
import ServiceAbroad from '@/components/home/serviceAbroad'
import ForeignCompanyService from '@/components/home/foreignCompanyService'
import HtmlContent from '@/components/home/htmlContent'
import SelfComponents from '@/components/home/selfComponents'

import specialServiceInformation from '@/components/home/specialServiceInformation'
import preliminaryExamination from '@/components/home/preliminaryExamination'
import query from '@/components/home/query'


import BusinessLobby from '@/components/content/businessLobby'
import SomeInter from '@/components/content/someInter'
import WindowServie from '@/components/content/windowService'
import officeServie from '@/components/content/officeService'
import specialService from '@/components/content/specialService'
import JapanVisa from '@/components/content/JapanVisa'
import SearchService from '@/components/content/searchService'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      redirect: '/home/home-index',
      children: [
        {
          path: 'home',
          name: 'home',
          component: Home,
          children: [
            {
              // 1. 外事首页
              path: 'home-index',
              name: 'home-index',
              component: HomeIndex,
            },
            {
              // 9.出国签证
              path: 'goaboard',
              name: 'goaboard',
              meta: { name: '出国签证' },
              component: Goaboard,
            },
            {
              // 11.领事认证
              path: 'consular-certification',
              name: 'consular-certification',
              meta: { name: '领事认证' },
              component: ConsularCertification,
            },
            {
              // 12.翻译服务
              path: 'translation-service',
              name: 'translation-service',
              meta: { name: '翻译服务' },
              component: TranslationService,
            },
            // {
            //   // 2.通知公告
            //   path: 'announcement',
            //   name: 'announcement',
            //   meta: {name: '信息列表'},
            //   component: Announcement,
            // },
            // {
            //   // 2.通知公告
            //   path: 'htmlContent',
            //   name: 'htmlContent',
            //   meta: {name: '信息列表'},
            //   component: HtmlContent,
            // },
            // {
            //   // 2.通知公告
            //   path: 'selfComponents',
            //   name: 'selfComponents',
            //   meta: {name: '信息列表'},
            //   component: SelfComponents,
            // },
            {
              // 2.搜索结果
              path: 'search',
              name: 'search',
              meta: { name: '搜索结果' },
              component: Search,
            },
            {
              // 14.机构概况
              path: 'institutional-overview',
              name: 'institutional-overview',
              meta: { name: '机构概况' },
              component: InstitutionalOverview,
            },
            {
              // 15. 出国服务ServiceAbroad
              path: 'service-abroad',
              name: 'service-abroad',
              meta: { name: '出国服务' },
              component: ServiceAbroad,
            },
            {
              // 16. 外企服务foreign-company-service
              path: 'foreign-company-service',
              name: 'foreign-company-service',
              meta: { name: '外企服务' },
              component: ForeignCompanyService,
            },
            {
              //13.联系我们
              path: 'contactUs',
              name: 'contactUs',
              meta: { name: '联系我们' },
              component: ContactUs,
            },
            // {
            //   // 3. 视频点播
            //   path: 'player',
            //   name: 'player',
            //   meta: {name: '视频点播'},
            //   component: Player,
            // },
            // {
            //   // 4. 办事指南信息
            //   path: 'guide',
            //   name: 'guide',
            //   meta: {name: '信息详情'},
            //   component: Guide,
            // },
          ]
        },
        {
          // 5. 窗口服务
          path: 'business-lobby',
          name: 'businessLobby',
          component: BusinessLobby
        },
        {
          // 5. 窗口服务
          path: 'search-service',
          name: 'searchService',
          component: SearchService
        },
        {
          // 6. 同声传译
          path: 'some-inter',
          name: 'some-inter',
          component: SomeInter
        },
        {
          // 7. 窗口服务
          path: 'window-service',
          name: 'window-service',
          meta: { name: '窗口业务' },
          component: WindowServie
        },
        {
          // 8. 办事服务
          path: 'office-service',
          name: 'office-service',
          meta: {
            name: '办事指南',
          },
          component: officeServie
        },
        {
          // 10. 出国签证详情页
          path: 'special-service',
          name: 'special-service',
          meta: { name: '出国签证' },
          component: specialService
        },

      ]
    },
    {
      // japan
      path: '/JapanVisa',
      name: 'Japan-visa',
      meta: { name: '出国签证' },
      component: JapanVisa
    },
    {
      // 2.通知公告
      path: '/htmlContent',
      name: 'htmlContent',
      meta: {
        name: '信息列表',
        isHidden: true
      },
      component: HtmlContent,
    },
    {
      // 2.通知公告
      path: '/announcement',
      name: 'announcement',
      meta: {
        name: '认证答疑',
      },
      component: Announcement,
    },
    {
      // 4. 办事指南信息
      path: '/guide',
      name: 'guide',
      meta: { name: '信息详情' },
      component: Guide,
    },
    {
      // 2.通知公告
      path: '/selfComponents',
      name: 'selfComponents',
      meta: { name: '信息列表' },
      component: SelfComponents,
    },
    {
      // 3. 视频点播
      path: '/player',
      name: 'player',
      meta: { name: '视频点播' },
      component: Player,
    },
    {
      // 4. 出国签证
      path: '/specialServiceInformation',
      name: 'specialServiceInformation',
      meta: {
        name: '我要预约',
        isHidden: true
      },
      component: specialServiceInformation,
    },
    {
      // 4. 出国签证
      path: '/preliminaryExamination',
      name: 'preliminaryExamination',
      meta: {
        name: '我要预约',
        isHidden: true
      },
      component: preliminaryExamination,
    },
    {
      // 4. 出国签证
      path: '/query',
      name: 'query',
      meta: {
        name: '我要预约',
        isHidden: true
      },
      component: query,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js